/**
 * @module PubSub
 * PubSub
 * @method PubSub
 * @author yanglang
 * @date 20170830
 */
import { Type } from '@common/enums/base';
import { type } from './index';
var Events = {};
var toBeNotify = [];
var EVENT_PREFIX = 'TPE';
var PubSub = {
    /*
     * @method notify
     * @param eventName
     * @returns {_}
     */
    notify: function (eventName) {
        var _this = this;
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        var eventList = Events[eventName];
        if (eventList) {
            eventList.forEach(function (e) { return e.apply(_this, rest); });
        }
        else {
            toBeNotify.push({
                eventName: eventName,
                data: rest,
                scope: this,
            });
        }
        if (eventName.startsWith(EVENT_PREFIX + "_")) {
            this.unsubscribe(eventName);
        }
        return this;
    },
    /*
     * @param eventName
     * @param scope
     * @param data
     */
    notifyWith: function (eventName, scope) {
        var rest = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            rest[_i - 2] = arguments[_i];
        }
        if (arguments.length < 2) {
            throw new TypeError('arguments error');
        }
        this.notify.apply(scope, [eventName].concat(rest));
    },
    /**
     * 触发一个事件
     * @method notify
     * @param eventName 事件名称
     * @param data 事件数据 PS：现在支持变参，除了eventName,data以外还可以添加任意参数
     * @returns {Events}
     */
    notifyLike: function (eventNamePrefix) {
        var _this = this;
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        /* eslint-disable */
        var eventList = [];
        for (var key in Events) {
            new RegExp("^" + eventNamePrefix + ".*$").test(key) && (eventList = eventList.concat(Events[key]));
        }
        if (eventList) {
            eventList.forEach(function (e) { return e.apply(_this, rest); });
        }
        return this;
        /* eslint-enable */
    },
    /*
     * @method subscribe
     * @param eventName
     * @param callback
     */
    subscribe: function (eventName, callback) {
        var i = 0;
        var len = toBeNotify.length;
        if (arguments.length < 2) {
            throw new TypeError('arguments error ');
        }
        var eventList = Events[eventName] ? Events[eventName] : (Events[eventName] = []);
        if (type(callback) === Type.Array) {
            Events[eventName] = eventList.concat(callback);
        }
        else {
            eventList.push(callback);
        }
        for (; i < len; i += 1) {
            if (toBeNotify[i].eventName === eventName) {
                this.notify.apply(toBeNotify[i].scope, [eventName].concat(toBeNotify[i].data));
                toBeNotify.splice(i, 1);
                break;
            }
        }
        return this;
    },
    /*
     * @method unsubscribe
     * @param eventName
     */
    unsubscribe: function (eventName, callback) {
        if (callback) {
            var callbacks = Events[eventName];
            for (var i = 0; i < callbacks.length; i += 1) {
                if (callbacks[i] === callback) {
                    callbacks.splice(i, 1);
                    i -= 1;
                }
            }
        }
        else {
            delete Events[eventName];
        }
        return this;
    },
    clear: function () {
        toBeNotify = [];
        Events = {};
    }
};
export default PubSub;
